export interface AnalysisPackMetadata {
    packageType?: string | null;
    sourceProjectName?: string | null;
    generatedAt?: string | null;
    packageHash?: string | null;
    packageId?: string | null;
}

export default class MLModelRevision {
    constructor(
        public storagePath: string,
        public isActive: boolean,
        public createDate: string,
        public fileSizeKilobytes: number | null,
        public manifestJson: string | null,
        public analysisPackMetadata?: AnalysisPackMetadata | null
    ) {
        this.storagePath = storagePath;
        this.isActive = isActive;
        this.createDate = createDate;
        this.fileSizeKilobytes = fileSizeKilobytes;
        this.manifestJson = manifestJson;
        this.analysisPackMetadata = analysisPackMetadata;
    }
}
